module.exports = __webpack_public_path__ + "static/img/payment _success.93fc424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment _success.png
// module id = miOG
// module chunks = 1